/* eslint-disable react/prop-types */
import {
  Snackbar,
  IconButton,
  Button,
  Typography,
  Slide,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import Alert from '../Alert';

function TransitionUp(props) {
  return <Slide {...props} direction="up" />;
}

const UpdateAlert = ({ showReload, reloadPage, setShowReload }) => {
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setShowReload(false);
  };

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      open={showReload}
      TransitionComponent={TransitionUp}
      onClose={handleClose}
      classes={{
        root: '',
      }}
    >
      <div className="w-full">
        <Alert
          onClose={handleClose}
          classes={{
            message: 'flex items-end',
            action: 'p-0 mr-3',
          }}
          severity="success"
          color="success"
          className="border border-indigo-200 shadow-xl"
          action={
            <div className="flex">
              <Button color="primary" size="small" className="ml-3 px-3" onClick={reloadPage}>
                بروز رسانی
              </Button>
              <IconButton
                classes={{
                  root: 'p-2',
                }}
                onClick={handleClose}
              >
                <Close fontSize="small" />
              </IconButton>
            </div>
          }
          message={
            <Typography
              className="font-bold text-gray-700 text-xs"
            >
              نسخه جدید بارگذاری شده
            </Typography>
          }
        />
      </div>
    </Snackbar>
  );
};

export default UpdateAlert;
